import { makeStyles } from "tss-react/mui"
import Checkbox from "@mui/material/Checkbox"
import MenuItem from "@mui/material/MenuItem"
import InputLabel from "@mui/material/InputLabel"
import FormControl from "@mui/material/FormControl"
import ListItemText from "@mui/material/ListItemText"
import OutlinedInput from "@mui/material/OutlinedInput"
import Select, { SelectChangeEvent } from "@mui/material/Select"
import { useAppLocalization } from "../../../../modules/localization/components/AppLocalizationProvider"
import { LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"
import { iterateStringEnum } from "../../../../lib/enums"
import { MenuProps } from "../constants/filterMenuConst"

export enum PaymentMethod {
    CREDIT_CARD = "CREDIT_CARD",
    CONTANT = "CONTANT",
    INVOICING = "INVOICING",
    WALLET = "WALLET",
    FREE = "FREE",
}
type StyleProps = Readonly<{
    size: "small" | "normal"
}>

const useStyles = makeStyles<StyleProps>()((_theme, { size }) => ({
    input: {
        width: size === "normal" ? "20rem" : "13rem",
    },
}))

type StandardPaymentMethodsFilterProps = Readonly<{
    value: string[]
    setValue: (value: string[]) => void
    size?: "small" | "normal"
}>

export function StandardPaymentMethodsFilter({ value, setValue, size = "normal" }: StandardPaymentMethodsFilterProps) {
    const { l10n } = useAppLocalization()
    const { classes } = useStyles({ size })

    const handleChange = (event: SelectChangeEvent<typeof value>) => {
        const {
            target: { value },
        } = event
        setValue(typeof value === "string" ? value.split(",") : value)
    }

    return (
        <FormControl className={classes.input}>
            <LocalizedStrict id="standard-payment-method-input-label">
                <InputLabel id="multiple-checkbox-payment-method-label">Payment method</InputLabel>
            </LocalizedStrict>
            <Select
                labelId="multiple-checkbox-payment-method-label"
                id="multiple-checkbox-payment-method"
                multiple
                value={value}
                onChange={handleChange}
                input={<OutlinedInput label="Payment method" />}
                renderValue={(selected) =>
                    selected.map((value) => l10n.getStringForEnum("standard-payment-method-item", value, "")).join(", ")
                }
                MenuProps={MenuProps}
            >
                {[...iterateStringEnum(PaymentMethod)].map((name) => (
                    <MenuItem key={name} value={name}>
                        <Checkbox checked={value.indexOf(name) > -1} />
                        <ListItemText primary={l10n.getStringForEnum("standard-payment-method-item", name, "")} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}
